import { React, PropTypes } from 'imports';
import RadioGroup from '../RadioGroup/RadioGroup';
import FormattedResource, { isResource } from 'typed/components/common/FormattedResource/FormattedResource';
import Tooltip from '../Tooltip/Tooltip';
import { Scale } from 'utils';
import './VoteScale.less';

export default class VoteScale extends React.PureComponent {
    static get propTypes() {
        return {
            scale: PropTypes.instanceOf(Scale).isRequired,
            value: PropTypes.number,
            defaultValue: PropTypes.number,
            compact: PropTypes.bool,
            clearable: PropTypes.bool,
            disabled: PropTypes.bool,
            className: PropTypes.string,
            title: FormattedResource.resourcePropType,
            lowLabel: FormattedResource.resourcePropType,
            highLabel: FormattedResource.resourcePropType,
            onChange: PropTypes.func
        }
    }

    static get defaultProps() {
        return {
            value: null,
            defaultValue: null,
            compact: false,
            clearable: false,
            disabled: false,
            className: '',
            title: { id: 'common.importance' },
            lowLabel: { id: 'common.low' },
            highLabel: { id: 'common.high' },
        }
    }

    _onChange = (sender, value) => {
        if (this.props.onChange) {
            this.props.onChange(this, value === this.props.defaultValue ? null : value);
        }
    }

    render() {
        return (
            <div className={'vote-scale ' + this.props.className}>
                {
                    this.props.title ?
                        <div className="title">
                            <FormattedResource resource={this.props.title} />
                        </div> :
                        null
                }
                {
                    !this.props.compact && this.props.lowLabel ?
                        <div className="label">
                            <FormattedResource resource={this.props.lowLabel} />
                        </div> :
                        null
                }
                <RadioGroup clearable={this.props.clearable} layout={RadioGroup.Layout.HORIZONTAL} appearance={RadioGroup.Appearance.BUTTON}
                    value={this.props.value || this.props.defaultValue}
                    disabled={this.props.disabled}
                    onChange={this._onChange}>
                    {this.props.scale.map(({ point, result }) => (
                        <RadioGroup.Option
                            key={point}
                            value={point}
                            disabled={(!this.props.value || this.props.value === this.props.defaultValue) && point === this.props.defaultValue}>
                            {!this.props.compact ? result : point}
                            {this.props.compact ? <Tooltip><FormattedResource resource={isResource(result) ? result : `${result}`} /></Tooltip> : null}
                        </RadioGroup.Option>
                    ))}
                </RadioGroup>
                {
                    !this.props.compact && this.props.highLabel ?
                        <div className="label">
                            <FormattedResource resource={this.props.highLabel} />
                        </div> :
                        null
                }
            </div>
        );
    }
}
